'use strict';

import ApiEndpoint from './api_endpoint';

export default class CreateProtocolSubscription extends ApiEndpoint {
  execute(callback = undefined, session = undefined, params = undefined) {
    if (session === undefined) {
      return this.session.post('/protocol_subscriptions', params, callback);
    }
    return session.post('/protocol_subscriptions', params, callback);
  }
}
